import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rastreador-form',
  templateUrl: './rastreador-form.component.html',
  styleUrls: ['./rastreador-form.component.scss']
})
export class RastreadorFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
